import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import apiService from '../services/apiService';

const AddSeller = () => {
  const navigate = useNavigate();
  const [sellerData, setSellerData] = useState({
    companyName: '',
    contactPerson: '',
    contactNumber: '',
    description: '',
    emailAddress: ''
  });
  const [saving, setSaving] = useState(false);

  const handleInputChange = (field, value) => {
    setSellerData({
      ...sellerData,
      [field]: value
    });
  };

  const handleSave = async () => {
    try {
      setSaving(true);

      // Check if all required fields are filled
      if (!sellerData.companyName || !sellerData.contactPerson || 
          !sellerData.contactNumber || !sellerData.emailAddress) {
        alert('Please fill in all fields');
        return;
      }

      // Validate contact number length
      if (sellerData.contactNumber.length > 20) {
        alert('Contact number cannot exceed 20 characters');
        return;
      }

      // Validate email format
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(sellerData.emailAddress)) {
        alert('Please enter a valid email address');
        return;
      }

      const requestBody = {
        userId: 3,
        companyName: sellerData.companyName,
        description: (sellerData.description || '').trim(),
        contactPerson: sellerData.contactPerson,
        contactNumber: sellerData.contactNumber,
        emailAddress: sellerData.emailAddress
      };

      console.log('Sending seller data:', requestBody); // Debug log

      const result = await apiService.post('/seller-companies', requestBody);
      console.log('Seller created successfully:', result);
      
      alert('Seller created successfully!');
      
      // Navigate back to manage sellers or clear the form
      navigate('/sellers');
      
    } catch (err) {
      console.error('Error creating seller:', err);
      alert('Failed to create seller. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="manage-properties">
      <div className="page-header">
        <h1>Add Seller</h1>
      </div>

      <div className="content-container">
        <div className="form-section">
          <h3>Company Information</h3>
          <div className="form-grid">
            <div className="form-row">
              <label htmlFor="companyName">Company Name:</label>
              <input
                type="text"
                id="companyName"
                className="form-input"
                value={sellerData.companyName}
                onChange={(e) => handleInputChange('companyName', e.target.value)}
              />
            </div>
            
            <div className="form-row">
              <label htmlFor="contactPerson">Contact Person:</label>
              <input
                type="text"
                id="contactPerson"
                className="form-input"
                value={sellerData.contactPerson}
                onChange={(e) => handleInputChange('contactPerson', e.target.value)}
              />
            </div>
            
            <div className="form-row">
              <label htmlFor="contactNumber">Contact Number:</label>
              <input
                type="text"
                id="contactNumber"
                className="form-input"
                value={sellerData.contactNumber}
                onChange={(e) => handleInputChange('contactNumber', e.target.value)}
                maxLength="20"
              />
            </div>

            <div className="form-row">
              <label htmlFor="emailAddress">Email Address:</label>
              <input
                type="email"
                id="emailAddress"
                className="form-input"
                value={sellerData.emailAddress}
                onChange={(e) => handleInputChange('emailAddress', e.target.value)}
              />
            </div>

            <div className="form-row form-row-span-full">
              <label htmlFor="description">Description:</label>
              <textarea
                id="description"
                className="form-textarea"
                rows={4}
                placeholder="Optional"
                value={sellerData.description}
                onChange={(e) => handleInputChange('description', e.target.value)}
              />
            </div>
          </div>
        </div>

        <div className="form-actions">
          <button 
            type="button" 
            className="btn-primary"
            onClick={handleSave}
            disabled={saving}
          >
            {saving ? 'Creating Seller...' : 'Create Seller'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddSeller;
